// Australian suburbs and cities data for location-based filtering
// Based on Korean-Australian community hubs

export interface SuburbInfo {
  id: string;
  name: string;
  nameKo?: string;
  state: string;
  lat?: number;
  lng?: number;
}

export const australianStates = [
  { id: "NSW", name: "New South Wales", nameKo: "뉴사우스웨일스" },
  { id: "VIC", name: "Victoria", nameKo: "빅토리아" },
  { id: "QLD", name: "Queensland", nameKo: "퀸즐랜드" },
  { id: "SA", name: "South Australia", nameKo: "남호주" },
  { id: "WA", name: "Western Australia", nameKo: "서호주" },
  { id: "TAS", name: "Tasmania", nameKo: "태즈매니아" },
  { id: "NT", name: "Northern Territory", nameKo: "노던 테리토리" },
  { id: "ACT", name: "Australian Capital Territory", nameKo: "수도 준주" },
  { id: "ALL", name: "All Regions", nameKo: "전체 지역" },
] as const;

// Major Korean-Australian community suburbs by state
export const suburbsByState: Record<string, SuburbInfo[]> = {
  NSW: [
    { id: "sydney", name: "Sydney", nameKo: "시드니", state: "NSW", lat: -33.8688, lng: 151.2093 },
    { id: "eastwood", name: "Eastwood", nameKo: "이스트우드", state: "NSW", lat: -33.7904, lng: 151.0810 },
    { id: "strathfield", name: "Strathfield", nameKo: "스트라스필드", state: "NSW", lat: -33.8764, lng: 151.0886 },
    { id: "epping", name: "Epping", nameKo: "에핑", state: "NSW", lat: -33.7723, lng: 151.0819 },
    { id: "chatswood", name: "Chatswood", nameKo: "챗스우드", state: "NSW", lat: -33.7969, lng: 151.1832 },
    { id: "burwood", name: "Burwood", nameKo: "버우드", state: "NSW", lat: -33.8764, lng: 151.1043 },
    { id: "lidcombe", name: "Lidcombe", nameKo: "리드컴", state: "NSW", lat: -33.8647, lng: 151.0434 },
    { id: "campsie", name: "Campsie", nameKo: "캠시", state: "NSW", lat: -33.9130, lng: 151.1033 },
    { id: "rhodes", name: "Rhodes", nameKo: "로즈", state: "NSW", lat: -33.8278, lng: 151.0873 },
    { id: "parramatta", name: "Parramatta", nameKo: "파라마타", state: "NSW", lat: -33.8151, lng: 151.0001 },
  ],
  VIC: [
    { id: "melbourne", name: "Melbourne", nameKo: "멜버른", state: "VIC", lat: -37.8136, lng: 144.9631 },
    { id: "glen-waverley", name: "Glen Waverley", nameKo: "글렌 웨이벌리", state: "VIC", lat: -37.8769, lng: 145.1621 },
    { id: "box-hill", name: "Box Hill", nameKo: "박스 힐", state: "VIC", lat: -37.8191, lng: 145.1238 },
    { id: "doncaster", name: "Doncaster", nameKo: "돈캐스터", state: "VIC", lat: -37.7868, lng: 145.1241 },
    { id: "clayton", name: "Clayton", nameKo: "클레이튼", state: "VIC", lat: -37.9256, lng: 145.1211 },
    { id: "bundoora", name: "Bundoora", nameKo: "번두라", state: "VIC", lat: -37.6985, lng: 145.0577 },
    { id: "city", name: "Melbourne CBD", nameKo: "멜번 시티", state: "VIC", lat: -37.8142, lng: 144.9632 },
  ],
  QLD: [
    { id: "brisbane", name: "Brisbane", nameKo: "브리즈번", state: "QLD", lat: -27.4698, lng: 153.0251 },
    { id: "sunnybank", name: "Sunnybank", nameKo: "써니뱅크", state: "QLD", lat: -27.5818, lng: 153.0621 },
    { id: "upper-mount-gravatt", name: "Upper Mount Gravatt", nameKo: "어퍼 마운트 그래밧", state: "QLD", lat: -27.5571, lng: 153.0811 },
    { id: "toowong", name: "Toowong", nameKo: "투웡", state: "QLD", lat: -27.4846, lng: 152.9906 },
    { id: "southport", name: "Southport", nameKo: "사우스포트", state: "QLD", lat: -27.9717, lng: 153.3969 },
  ],
  SA: [
    { id: "adelaide", name: "Adelaide", nameKo: "애들레이드", state: "SA", lat: -34.9285, lng: 138.6007 },
    { id: "norwood", name: "Norwood", nameKo: "노우드", state: "SA", lat: -34.9192, lng: 138.6294 },
    { id: "prospect", name: "Prospect", nameKo: "프로스펙트", state: "SA", lat: -34.8847, lng: 138.5941 },
  ],
  WA: [
    { id: "perth", name: "Perth", nameKo: "퍼스", state: "WA", lat: -31.9505, lng: 115.8605 },
    { id: "canning-vale", name: "Canning Vale", nameKo: "캐닝 베일", state: "WA", lat: -32.0615, lng: 115.9189 },
    { id: "willetton", name: "Willetton", nameKo: "윌레튼", state: "WA", lat: -32.0499, lng: 115.8839 },
  ],
  ACT: [
    { id: "canberra", name: "Canberra", nameKo: "캔버라", state: "ACT", lat: -35.2809, lng: 149.1300 },
    { id: "belconnen", name: "Belconnen", nameKo: "벨코넨", state: "ACT", lat: -35.2382, lng: 149.0656 },
  ],
  TAS: [
    { id: "hobart", name: "Hobart", nameKo: "호바트", state: "TAS", lat: -42.8821, lng: 147.3272 },
  ],
  NT: [
    { id: "darwin", name: "Darwin", nameKo: "다윈", state: "NT", lat: -12.4634, lng: 130.8456 },
  ],
  ALL: [],
};

// Get all suburbs for a specific state
export function getSuburbsByState(stateId: string): SuburbInfo[] {
  return suburbsByState[stateId] || [];
}

export function getCanonicalSuburbName(
  stateId: string,
  value?: string | null,
): string | undefined {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return undefined;

  const match = getSuburbsByState(stateId).find(
    (suburb) =>
      suburb.id.toLowerCase() === normalized ||
      suburb.name.toLowerCase() === normalized ||
      suburb.nameKo?.toLowerCase() === normalized,
  );
  return match?.name || String(value).trim();
}

// Get state from coordinates (rough estimation based on lat/lng ranges)
export function getStateFromCoordinates(lat: number, lng: number): string {
  // ACT: Canberra area (more precise bounds)
  // Canberra: lat: -35.2809, lng: 149.1300
  // ACT is a small territory, so use tighter bounds
  if (lat >= -35.5 && lat <= -35.0 && lng >= 148.8 && lng <= 149.4) {
    return "ACT";
  }

  // NSW: roughly -37 to -28 lat, 141 to 154 lng
  if (lat >= -37 && lat <= -28 && lng >= 141 && lng <= 154) {
    return "NSW";
  }
  // VIC: roughly -39 to -34 lat, 141 to 150 lng
  if (lat >= -39 && lat <= -34 && lng >= 141 && lng <= 150) return "VIC";
  // QLD: roughly -29 to -10 lat, 138 to 154 lng
  if (lat >= -29 && lat <= -10 && lng >= 138 && lng <= 154) return "QLD";
  // SA: roughly -38 to -26 lat, 129 to 141 lng
  if (lat >= -38 && lat <= -26 && lng >= 129 && lng <= 141) return "SA";
  // WA: roughly -35 to -13 lat, 113 to 129 lng
  if (lat >= -35 && lat <= -13 && lng >= 113 && lng <= 129) return "WA";
  // TAS: roughly -44 to -39 lat, 144 to 149 lng
  if (lat >= -44 && lat <= -39 && lng >= 144 && lng <= 149) return "TAS";
  // NT: roughly -26 to -10 lat, 129 to 138 lng
  if (lat >= -26 && lat <= -10 && lng >= 129 && lng <= 138) return "NT";

  return "ALL";
}

// Find nearest suburb from coordinates
export function getNearestSuburb(lat: number, lng: number, stateId?: string): SuburbInfo | null {
  const state = stateId || getStateFromCoordinates(lat, lng);
  const suburbs = getSuburbsByState(state);

  if (suburbs.length === 0) return null;

  let nearest: SuburbInfo | null = null;
  let minDistance = Infinity;

  suburbs.forEach(suburb => {
    if (suburb.lat && suburb.lng) {
      // Calculate rough distance using Haversine formula
      const distance = Math.sqrt(
        Math.pow(suburb.lat - lat, 2) + Math.pow(suburb.lng - lng, 2)
      );

      if (distance < minDistance) {
        minDistance = distance;
        nearest = suburb;
      }
    }
  });

  return nearest;
}
